import React from "react";
import {useLocation, useParams} from "react-router-dom";

import PageHeader from "src/componets/PageHeader";
import NavBarTwo, { parentInterface } from "src/componets/NavBarTwo";
import NavBarThree from "src/componets/NavBarThree";
import {PlusOutlined, SettingOutlined} from "@ant-design/icons";
import { selectCategoryIds, setNewParams, setReorderIds } from "src/store/community/categoriesSlice";
import { useAppDispatch, useAppSelector } from "src/store/hooks";

interface PropsInterface {
  title: string;
  navs: {[index: number]: any};
  parent?: parentInterface;
  target: 'content' | 'community';
}

const _PageHeader = ({ title, navs, parent, target }: PropsInterface) => {
  const { pathname }  = useLocation();
  const dispatch = useAppDispatch();
  const activeItem    = Object.values(navs).find(e => e.url === pathname);
  const ids = useAppSelector(selectCategoryIds);
  const { app_id } = useParams();

  function onClickCreate() {
    dispatch(setNewParams({ app_id: app_id, target: target }));
  }

  function onClickSettings() {
    dispatch(setReorderIds({ ids }));
  }


  return (
    <PageHeader
      title={title}
      breadcrumbs={[activeItem?.name]}
    >
      <NavBarTwo
        items={navs}
        itemIds={Object.keys(navs)}
        activeId={activeItem?.id}
        parent={parent}
      />

      <NavBarThree>
        <NavBarThree.Button onClick={onClickSettings}>
          <SettingOutlined /> Category Settings
        </NavBarThree.Button>
        <NavBarThree.Button onClick={onClickCreate}>
          <PlusOutlined /> Create Category
        </NavBarThree.Button>
      </NavBarThree>
    </PageHeader>
  );
}

export default _PageHeader;
